import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { ScopeDescription } from '../../../models/api-key/dto/api-key.dto';
import { GET_API_KEY_SCOPES_QUERY_KEY } from './constants';

type Response = { scopes: ScopeDescription[] };

export const useGetScopes = (organizationId: string) => {
  const client = useApiClient();
  return useQuery({
    queryKey: GET_API_KEY_SCOPES_QUERY_KEY(organizationId),
    queryFn: () =>
      client.fetchApi<Response, undefined>({
        endpoint: `organizations/${organizationId}/api-keys/scopes`,
        method: 'GET',
      }),
    enabled: !!organizationId,
    staleTime: 5 * 60 * 1000, // 5 min — scopes don't change often
  });
};
